import api from '../../api/_resultats-analyse'

const state = () => ({
    resultsMode: 'add',//or edit
    resultatsAnalyse: null,
    patientMeta: {
        patient_fullname: '',
        patient_age: '',
        patient_gender: '',
        patient_phone: '',
        doctor_fullname: '',
        clinical_inquiries: '',
        methodology_applied: '',
    },
    patientBulletins: [],
    groupedResults: undefined,
    patientPrintedGroupedResults: {},
})

const getters = {

    resultsMode: (state) => {
        return state.resultsMode
    },

    resultatsAnalyse: (state) => {
        return state.resultatsAnalyse
    },

    patientMetaData: (state) => {
        return state.patientMeta
    },

    patientBulletins: (state) => {
        return state.patientBulletins
    },

    groupedResults: (state) => {
        return state.groupedResults
    },

    patientPrintedGroupedResults: (state) => {
        return state.patientPrintedGroupedResults
    }
}

const actions = {
    async saveResultatsAnalyse(_, { demande_analyse_id, data }) {   
        return await api.saveResultatsAnalyse(demande_analyse_id, data);
    },
    
    async updateResultatsAnalyse(_, data) {
        return await api.updateResultatsAnalyse(data)
    },

    async deleteResultatsAnalyse(_, resultatAnalyseId) {
        return await api.deleteResultatsAnalyse(resultatAnalyseId)
    },

    async getResultsByAnalyseIdBulletinId(_, { demande_analyse_id }) {
        return await api.getResultsByAnalyseIdBulletinId(demande_analyse_id)
    },

    async getBulletinsByPatientId(_, patientId) {
        return await api.getBulletinsByPatientId(patientId)
    },

    async saveGroupedAnalyses({ commit }, { patientId, data }) {
        try {
            const response = await api.saveGroupedAnalyses(patientId, data);
            
            if (response.status === 200 || response.status === 201) {
                commit('SET_GROUPED_RESULTS', response.data);
            }
    
            return response;
        } catch (error) {
            return error.response;
        }
    },

    async getGroupedAnalysesByPatientId({ commit }, patientId) {
        try {
            const response = await api.getGroupedAnalysesByPatientId(patientId);
            
            if (response.status === 200) {
                commit('SET_PRINTED_GROUPED_RESULTS', response.data);
            }
    
            return response;
        } catch (error) {
            return error.response;
        }
    },

    async deleteGroupedAnalyse(_, { patientId, groupedAnalyseId }) {
        return await api.deleteGroupedAnalyse(patientId, groupedAnalyseId);
    },

    setResultsMode({ commit }, resultsMode) {
        commit('SET_RESULTS_MODE', resultsMode)
    },

    setResultatsAnalyse({ commit }, resultatsAnalyse) {
        commit('SET_RESULTATS_ANALYSE', resultatsAnalyse)
    },
    setPatientMetaData({ commit }, data) {
        commit('SET_PATIENT_META', data)
    },
    setPatientBulletins({ commit }, data) {
        commit('SET_BULLETINS', data)
    },
    setGroupedResults({ commit }, data) {
        commit('SET_GROUPED_RESULTS', data)
    },
}

const mutations = {
    SET_RESULTS_MODE(state, resultsMode) {
        state.resultsMode = resultsMode
    },
    SET_RESULTATS_ANALYSE(state, data) {
        state.resultatsAnalyse = data
    },
    SET_PATIENT_META(state, data) {
        state.patientMeta = data
    },
    SET_BULLETINS(state, data) {
        state.patientBulletins = data
    },
    SET_GROUPED_RESULTS(state, data) {
        state.groupedResults = data
    },
    SET_PRINTED_GROUPED_RESULTS(state, data) {
        state.patientPrintedGroupedResults = data
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}
